export default "__VITE_ASSET__fPRPEDI4__"